import { createSelector } from "reselect";

const getReportActions = (state: any) => state.vpo.data_get_report_actions;

export const selectReportActions = createSelector([getReportActions], (dataReportActions) => {
  return dataReportActions;
});

export const selectReportActionsStatus = (state: any) => state.vpo.status_get_report_actions;
